import React, { Component, Fragment } from "react";

import Immutable, { is } from "immutable";

import * as XLSX from 'xlsx';

import axios from "axios";

import { Table, Container, Row, InputGroup, Col, Navbar, NavbarBrand, Nav, NavItem, NavLink, Card, CardBody, CardTitle, CardSubtitle, CardText, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, ButtonGroup, FormGroup, Label, Input } from "reactstrap";
import moment from "moment";
import HeaderComponent from "../header/HeaderComponent";
import TagComponent from "../element/TagComponent";
import TaskComponent from "../element/TaskComponent";
import LoadingScreen from "../element/LoadingScreen";

import LinearGauge from "../element/LinearGauge";
import '../../css/ImageTable.css';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell, BarChart, Bar, Area, AreaChart } from "recharts";
const { Base64 } = require("js-base64");

const COLORS = ["#0088FE", "#ff9999", "#FFBB28", "#FF8042"];
class StatusPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            only_today: false,
            productCheckStatusData: [],
            projectStatData: [],
            productCount: 0,
            acceptCount: 0,
            rejectCount: 0,
            selectedProjectName: [],
            project_list: []

        };

        this.modalRef = React.createRef();
        window.that = this;
    }







    handleClickOutside = (event) => {
        console.log("click outside")
        if (this.modalRef.current && !this.modalRef.current.contains(event.target)) {
            this.closeModal();
        }
    };


    closeMixModal = () => {

        this.setState({ mixModalOpen: false });
    };
    mixModalOpen = () => {
        this.setState({ mixModalOpen: true });
    }
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
        window.removeEventListener("keydown", this.handleKeyPress);
    }


    async componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
        window.addEventListener("keydown", this.handleKeyPress);
        this.getProjectList();

        const searchParams = new URLSearchParams(window.location.search);
        let paramValue = searchParams.get("project_name");
        console.log(paramValue);
        if (paramValue) {
            this.setState({ selectedProjectName: paramValue })
        }
        await this.initilizeData();
    }
    initilizeData = async () => {
        const productCheckStatusData = await this.getProductStatData();
        const projectStatData = await this.getProjectStatData();
        const { product_count } = await this.getStat();

        //count accept and reject 
        const { acceptCount, rejectCount } = projectStatData.reduce((acc, record) => {

            acc.acceptCount += parseInt(record.accept_count);
            acc.rejectCount += parseInt(record.reject_count);
            return acc;



        }, { acceptCount: 0, rejectCount: 0 })

        this.setState({
            productCheckStatusData: productCheckStatusData,
            projectStatData: projectStatData,
            productCount: product_count,
            acceptCount: acceptCount,
            rejectCount: rejectCount
        })

    }
    getStat = async () => {
        const result = await axios({
            method: "GET",
            url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/charan/stat/stat`,
            params: {

            },
            headers: {
                Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
            },
        });
        const product_count = JSON.parse(result.data.body).product_count;

        return { product_count }

    };
    getProjectStatData = async () => {
        const result = await axios({
            method: "GET",
            url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/charan/stat/project/projectStat`,
            params: {

            },
            headers: {
                Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
            },
        });
        const project_status = JSON.parse(result.data.body).project_status;

        return project_status

    };
    getProductStatData = async () => {
        const result = await axios({
            method: "GET",
            url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/charan/stat/product/productStat`,
            params: {

            },
            headers: {
                Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
            },
        });
        const product_check_records = JSON.parse(result.data.body).product_check_records;

        return product_check_records

    };


    getProjectList = async () => {
        const result = await axios({
            method: "Get",
            url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/charan/project/list`,
            params: {


            },
            headers: {
                Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
            },
        });
        const projects = JSON.parse(result.data.body).project_list;
        projects.unshift({ project_name: "프로젝트 선택" })
        this.setState({
            project_list: projects,

            //selectedProjectName: "rlabs_241118"
        }, () => {



        });
    }


    setCurrentSelectedTask = (task) => {
        this.setState({ currentSelectedTask: task });
    }

    // Open modal if Ctrl is pressed when clicking on result image
    handleResultClick = (item) => {

        let url = "";
        this.getProductTask(item.seq1);
        this.setState({ currentItem: item, isModalOpen: true, modalImageSrc: this.generateImageUrl(item), modalImageSrc2: this.generateResultUrl(item) }, () => {
            this.getProductTask(item.seq1);
        },);

    };

    // Close the modal
    closeModal = () => {
        console.log("modal closed");
        this.setState({ isModalOpen: false, modalImageSrc: '', isRejctModelOpen: false, rejectTargetIdx: undefined, isShowRejectReasonOpen: false });
    };



    onValueChanged = (name, value) => {

        console.log("name:", name, ",value:", value)

        this.setState({
            [name]: value

        }, () => {
            if (name == "selectedProjectName") {
                this.getProductData();
            }
        });

    };
    toggleExcludeEvaluated = () => {
        // Toggle excludeEvaluated state
        this.setState((prevState) => ({
            excludeEvaluated: !prevState.excludeEvaluated
        }));
    };


    getCurrentStatus = (status) => {
        if (status == "accept") {
            return (<span style={{ fontWeight: "bold", color: "green" }}>수락</span>)
        }
        else if (status == "hold") {
            return (<span style={{ fontWeight: "bold", color: "orange" }}>보류</span>)
        }
        else if (status == "reject") {
            return (<span style={{ fontWeight: "bold", color: "red" }}>제외</span>)
        }
        else {
            return (<span style={{ fontWeight: "bold", color: "purple" }}>검수 전</span>)
        }
    }
    getCurrentTile = (status) => {
        if (status == "accept") {
            return (<h2 style={{ fontWeight: "bold", color: "green" }}>현재상태 : 수락</h2>)
        }
        else if (status == "hold") {
            return (<h2 style={{ fontWeight: "bold", color: "orange" }}>현재상태 : 보류</h2>)
        }
        else if (status == "fail") {
            return (<h2 style={{ fontWeight: "bold", color: "red" }}>현재상태 : 실패</h2>)
        }
        else {
            return (<h2 style={{ fontWeight: "bold", color: "purple" }}>현재상태 : 검수 전</h2>)
        }
    }
    render() {
        const compomentHeight = 300;

        return (
            <Fragment>
                <LoadingScreen isLoading={this.state.isLoading} />

                <HeaderComponent signOut={this.props.cognito.signOut} setStage={this.props.setStage} stage={this.props.stage}></HeaderComponent>
                <div className="main_contents">
                    <Container fluid>
                        <Row className="x_title_graph" style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
                            <Col md={3}>
                                <ButtonGroup>
                                    {/* <Button
                                        color="primary"
                                        outline
                                        onClick={() => {
                                            this.toggleExcludeOnlyToday();
                                        }}
                                        active={this.state.only_today}
                                    >
                                        당일 데이터
                                    </Button> */}
                                </ButtonGroup>
                            </Col>
                            <Col md={6} style={{ alignItems: "center", display: "flex", fontSize: 25, color: "black", fontWeight: 800, justifyContent: "center" }}>
                                {"주요 통계"}
                            </Col>

                            <Col md={3}>
                                <Input value={this.state.selectedProjectName} onChange={(e) => this.onValueChanged("selectedProjectName", e.target.value)} id="selectedProjectName" name="selectedProjectName" type="select">

                                    {this.state.project_list.map((item) => (
                                        <option value={item.project_name}>{item.project_name}</option>
                                    )
                                    )}


                                </Input>
                            </Col>
                        </Row>
                        <Row>
                            <Col className={"p-1"} sm={{ size: "6" }}>
                                <Col className="" sm={{ size: "12" }}>
                                    <div className="x_title_graph">프로젝트 별 통계</div>
                                    <div className="" style={{ height: compomentHeight }}>
                                        <ResponsiveContainer width="100%" height="100%">
                                            <BarChart
                                                data={this.state.projectStatData}
                                                margin={{
                                                    top: 5,
                                                    right: 30,
                                                    left: 20,
                                                    bottom: 5,
                                                }}
                                            >
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis type="category" dataKey="project_name" />
                                                <YAxis unit="개" />
                                                <Legend />
                                                <Tooltip />

                                                <Bar name="accept" isAnimationActive={false} type="monotone" dataKey="accept_count" fill={COLORS[0]} label={{ position: "top" }} />
                                                <Bar name="reject" isAnimationActive={false} type="monotone" dataKey="reject_count" fill={COLORS[1]} label={{ position: "top" }} />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                </Col>
                            </Col>
                            <Col className={"p-1"} sm={{ size: "3" }}>
                                <Col className="" sm={{ size: "12" }}>
                                    <div className="x_title_graph" style={{}}>
                                        전체 프로덕트 검수비율
                                    </div>
                                    <div className="" style={{ height: compomentHeight }}>
                                        <ResponsiveContainer width="100%" height="100%">

                                            <PieChart width={400} height={800} isAnimationActive={false}>
                                                <Pie
                                                    isAnimationActive={false}
                                                    data={this.state.productCheckStatusData}
                                                    dataKey="count"
                                                    outerRadius={100}
                                                    fill="#8884d8"
                                                    labelLine={true}
                                                    label={(obj) => {
                                                        return `${obj.value.toLocaleString('en-US')}(${(obj.percent * 100).toFixed(2)}%)`;
                                                    }}
                                                >
                                                    {this.state.productCheckStatusData.map((entry, index) => (
                                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                                    ))}
                                                </Pie>
                                                <Legend
                                                    formatter={(value, entry) => {
                                                        return `${entry.payload.customer_check_status}:${entry.payload.count.toLocaleString('en-US')}`;
                                                    }}
                                                />
                                            </PieChart>

                                        </ResponsiveContainer>
                                    </div>
                                </Col>
                            </Col>
                            <Col className={"p-1"} sm={{ size: "3" }}>
                                <Col className="" sm={{ size: "12" }}>
                                    <div className="x_title_graph">주요 지표</div>
                                    <div className="" style={{ height: compomentHeight, overflowY: "scroll" }}>
                                        <table style={{ width: "100%" }}>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "50%" }}>지표명</th>
                                                    <th style={{ width: "50%" }}>지표</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>이번 달 프로덕트</td>
                                                    <td>{this.state.productCount.toLocaleString('en-US')}</td>
                                                </tr>
                                                <tr>
                                                    <td>수락 프로덕트</td>
                                                    <td>{this.state.acceptCount.toLocaleString('en-US')}</td>
                                                </tr>
                                                <tr>
                                                    <td>제외 프로덕트</td>
                                                    <td>{this.state.rejectCount.toLocaleString('en-US')}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </Col>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </Fragment >
        );
    }
}

export default StatusPage;
